import ActionMessageId from '../../schema/ActionMessageId';
import ActionType from '../../schema/ActionType';
import AttachmentFullViewState from '../../schema/AttachmentFullViewState';
import addCompletedAction from '../addCompletedAction';
import setOngoingActionAndActionMessage from '../setOngoingActionAndActionMessage';
import { AttachmentModel } from 'owa-attachment-model-store';
import { isStringNullOrWhiteSpace } from 'owa-strings';

export default function initializeSaveToCloudStatus(
    viewState: AttachmentFullViewState,
    attachment: AttachmentModel,
    isSaveToCloudSupported: boolean
) {
    if (
        isSaveToCloudSupported &&
        !isStringNullOrWhiteSpace(attachment.model.AttachmentOriginalUrl)
    ) {
        addCompletedAction(viewState, ActionType.SaveToCloud);
        setOngoingActionAndActionMessage(
            viewState,
            ActionType.None,
            ActionMessageId.SaveToCloudCompleted
        );
    }
}
